import { useDispatch } from 'react-redux'
import { useCallback } from 'react'

import { addSpotToCheckQueue, removeSpotFromCheckQueue } from 'actions/spot'

export const useDetectConflicts = () => {
  const dispatch = useDispatch()
  const addSpot = useCallback((spot) => dispatch(addSpotToCheckQueue(spot)), [dispatch])
  const removeSpot = useCallback((spot) => dispatch(removeSpotFromCheckQueue(spot)), [dispatch])

  return [addSpot, removeSpot]
}
